export const VALIDATION_PATTERNS = {
  REDEEM_CODE: /^[A-Z0-9]{16,32}$|^[A-Z]{2,}-[A-Z0-9]{4,}$/,
  ACCESS_TOKEN_LENGTH: [44, 45],
  REFRESH_TOKEN_MIN_LENGTH: 500
};

export const UI_TEXT = {
  CONFIRM_DIALOG: {
    TITLE: '确认充值信息',
    DESCRIPTION: '请仔细核对以下信息，确认后将立即开始充值：',
    WARNING: '⚠️ 注意：充值操作不可撤销，请确保信息准确无误！',
    CONFIRM_BUTTON: '确认充值',
    CANCEL_BUTTON: '取消'
  },
  TASK_MODE: {
    SINGLE: '单个充值',
    BATCH: '批量充值'
  },
  STATUS_TEXT: {
    WAITING: '等待中',
    PROCESSING: '处理中',
    COMPLETED: '已完成',
    FAILED: '失败',
    TIMEOUT: '超时'
  }
};

export const EXTERNAL_LINKS = {
  CHATGPT_URL: 'https://chat.openai.com',
  SESSION_API: 'https://chatgpt.com/api/auth/session'
};